import { set } from 'src/utils/vuex'

export const SET_USER = set('user')
export const SET_COMPANY = set('company')
export const SET_TOKENS = set('tokens')

export function LOGIN (state, {
  user,
  company,
  accessToken,
  refreshToken,
}) {
  state.user = user
  state.company = company
  state.tokens = { accessToken, refreshToken }
}

export function LOGOUT (state) {
  state.user = null
  state.company = null
  state.tokens = null
}
